NtechApp.GridManager = function() {
    var me = this;

    me._click = new NtechApp.TouchClickEvent();
    me._fullscreenGrids = [];

    me._bindFullscreenGrids();

    return this;
};

NtechApp.proto(NtechApp.GridManager, {
    _bindFullscreenGrids: function() {
        var me = this;
        $.each($("body").find("[data-fullscreenGrid]"), function () {
            me._createFullscreenGrid($(this));
        });
    },

    _createFullscreenGrid: function($grid) {
        var grid = new NtechApp.FullscreenGrid($grid);
        this._fullscreenGrids.push(grid);
    }
});